import * as React from 'react'
import { User } from '../types'
import { createGuest } from '@/lib/user'

export const AuthContext = React.createContext<User>(createGuest())
export const useUser = () => React.useContext<User>(AuthContext)
